export default __webpack_public_path__ + "static/media/egallandt.c87b9837.png";